



























































































import Vue, { PropType } from 'vue'
import { debounce } from 'debounce'
import models from '@/mixins/models-mixin'
import persons from '@/mixins/persons-mixin'
import { mapGetters } from 'vuex'
import Person from '@/types/Person.interface'
import LoadingMask from '@/components/LoadingMask.vue'
import Analytics from '@/services/Analytics'
export default Vue.extend({
    mixins: [models, persons],
    components: { LoadingMask },
    props: {
        //  Determines if the control is focused when mounted
        autofocus: {
            type: Boolean,
            default: false
        },
        //  Determines if the type of person select is for broadcasts compose
        broadcastSelector: {
            type: Boolean,
            default: false
        },
        //  Applies the 'clearable' attribute, show the 'clear' icon
        clearable: {
            type: Boolean,
            default: false
        },
        //  The color of our control
        color: {
            type: String,
            default: 'primary'
        },
        //  Applies the compact style
        compact: {
            type: Boolean,
            default: false
        },
        //  Applies the 'dense' style
        dense: {
            type: Boolean,
            default: false
        },
        //  Determines if the autocomplete is disabled or not
        disabled: {
            type: Boolean,
            default: false
        },
        //  Persons to be excluded from this component
        excludePersons: {
            type: Array,
            default: null
        },
        //  Determines if menu should be expanded
        expanded: {
            type: Boolean,
            default: false
        },
        //  Applies 'hide-details' styling to the component
        hideDetails: {
            type: Boolean,
            default: false
        },
        //  The label displayed on our control
        label: {
            type: String,
            default: 'Search for a contact or user'
        },
        //  The icon displayed in the prepend-icon slot
        icon: {
            type: String,
            default: null
        },
        //  Hides the auto-complete list, and returns results in 'searchCompleted' event
        noList: {
            type: Boolean,
            default: false
        },
        //  Omits the drop down icon when true
        omitIcon: {
            type: Boolean,
            default: false
        },
        //  Applies the 'outlined' style to the component
        outlined: {
            type: Boolean,
            default: false
        },
        //  Determines if the parent component handles contact creation
        parentCreate: {
            type: Boolean,
            default: false
        },
        //  The text displayed in the autocomplete placeholder
        placeholder: {
            type: String,
            default: null
        },
        //  For setting unqiue id where two of the same components might be used
        type: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            duplicates: [],
            duping: false,
            expand: false,
            loading: false,
            menuProps: {
                offsetOverflow: false,
                bottom: true
            },
            recentPersonsList: null,
            searchtext: null,
            searchList: [],
            selectedPerson: null
        }
    },
    async mounted() {
        //  If for broadcast, get recent personsList
        if (this.broadcastSelector) this.getRecentPersonsList()

        //  If expanded prop is set, expand list
        if (this.expanded) {
            //  Setting a 300 millisecond delay to accomodate any transitions
            setTimeout(() => {
                this.$refs.personsAutocomplete.isMenuActive = true
                this.$refs.personsAutocomplete.isFocused = true
                this.$refs.personsAutocomplete.hasColor = true
            }, 300)
        }
    },
    computed: {
        ...mapGetters({
            lastPage: 'personsAutocompleteLastPage',
            nextPage: 'personsAutocompleteNextPage',
            optedOut: 'optedOut',
            persons: 'persons',
            personCreateInputs: 'personCreateInputs',
            personCreateMinInputs: 'personCreateMinInputs',
            tenant: 'tenant'
        }),
        filteredPersons(): Person[] {
            //  Grab our persons
            const persons = this.persons

            //  If there aren't any, return null
            if (!persons) return null

            //  else, filter out any users
            let filtered = persons.filter((x: Person) => !x.user_id)

            //  If excludePersons is specified, exclude persons
            if (this.excludePersons) {
                //  Create a new set by filtering by person ids
                filtered = filtered.filter(({ id }) => !this.excludePersons.includes(id))

                //  Filter out opted out contacts
                filtered = filtered.filter(
                    ({ phone_default }) => !this.optedOut.includes(phone_default.msisdn)
                )
            }

            //  Return our filtered users
            return filtered
        },
        items(): Person[] {
            //  2nd in list hierarchy is searchList
            if (this.searchList) return this.searchList

            //  3rd is list hierarchy is the paginate autocompleteList
            if (this.filteredPersons) return this.filteredPersons

            //  Last in list hierarchy is a default empty list
            return []
        },
        formStyle() {
            if (this.compact) return 'caption compact'
        },
        nameIsOptional() {
            const optional =
                this.tenant.data_provider !== 'QBO' &&
                this.tenant.data_provider !== 'XERO'
            return optional
        },
        searchProp: {
            get() {
                return this.searchtext
            },
            set: debounce(function (value) {
                this.searchtext = value
                this.personsSearch()
                this.duplicatesSearch()
            }, 750)
        }
    },
    methods: {
        async duplicatesSearch() {
            //  If empty, do nothing
            if (!this.searchtext) return (this.duplicates = [])

            //  If non-numeric, do nothing
            if (isNaN(this.searchtext)) return (this.duplicates = [])

            //  Start searching
            this.duping = true

            //  Grab our search text
            const phone = this.searchtext

            //  Else, remove invalid characters from the phone
            const f = this.$options.filters.phoneTrim(phone)

            //  We expect a complete number to be ten digits
            if (f.length !== 10) {
                // Needed to stop loading icon from persisting permanently
                this.duping = false

                return (this.duplicates = [])
            }

            //  Send the search request
            this.duplicates = await this.$store.dispatch('phoneNumbersDuplicates', f)

            //  We're done looking for dupes so disable
            this.duping = false
        },
        expandList(): void {
            //  Expand person list
            this.expand = true

            //  Get selector element
            var element = document.getElementById(`broadcastPersonSelector${this.type}`)

            //  Add css class for border
            element.classList.add('custom-border')
        },
        unexpand(): void {
            // Unexpand list
            this.expand = false

            //  Get selector element
            var element = document.getElementById(`broadcastPersonSelector${this.type}`)

            //  Add css class for border
            element.classList.remove('custom-border')
        },
        formatName(person: Person): string {
            //  Grab the person's full name or email
            const personFullNameOrEmail =
                this.$options.filters.personFullNameOrEmail(person)

            //  If full name is null, return default phone number (backup)
            if (!personFullNameOrEmail) return person.phone_default.msisdn

            //  The length depends on viewport
            const len = this.$vuetify.breakpoint.mdAndUp ? 15 : 20

            //  If the string length is greater than 15
            if (personFullNameOrEmail.length > len)
                //  Return the first 15 characters along with three dots
                return personFullNameOrEmail.substring(0, len) + '...'

            //  Else just return the name
            return personFullNameOrEmail
        },
        async getRecentPersonsList(): Promise<void> {
            //  Get the last 10 created contacts
            let tempList = await this.$store.dispatch('personsRecentPaginate')

            if (!tempList) return

            //  If excludePersons is specified, exclude persons
            if (this.excludePersons) {
                //  Create a new set by filtering by person ids
                tempList = tempList.filter(({ id }) => !this.excludePersons.includes(id))

                //  Filter out opted out contacts
                tempList = tempList.filter(
                    ({ phone_default }) => !this.optedOut.includes(phone_default.msisdn)
                )
            }

            //  Set the list
            this.recentPersonsList = tempList
        },
        handleExtra(): void {
            //  If we don't have duplicates then create a new contact
            if (!this.duplicates.length)
                return this.handleCreate(this.searchtext, this.onPersonSelectedHandler)

            //  Else, navigate to the dupe
            this.onPersonSelected(this.duplicates[0])
        },
        onFocus(): void {
            //  Get the menu content div in the Autocomplete
            let el = document.querySelector('.v-menu__content')

            //  Recursive wait for DOM to load the menu component
            if (!el) setTimeout(this.onFocus, 500)
            //  Add the scroll event listener to the autocomplete's menu
            else el.addEventListener('scroll', this.onMenuScroll)
        },
        onMenuScroll: debounce(function (event): void {
            //  Get the element from the DOM
            const el = event.target

            //  Get the height of the menu
            const height = el.clientHeight

            //  Get the current scroll position
            const position = el.scrollTop

            //  Check if the scroll position is at the bottom
            const bottom = position + height >= el.scrollHeight

            //  If scroll is at the bottom of the menu, we need to pagiante
            if (bottom) this.paginate()
        }, 200),
        onPersonSelectedHandler(person: Person): void {
            //  If the person does NOT exist, do nothing
            if (!person) return

            //  Submit this to the parent
            this.onPersonSelected(person)
        },
        onPersonSelected(person: Person): void {
            //  Else, emit selected person event to parent component
            this.$emit('personSelected', person)

            this.$nextTick(() => {
                //  Clear the autocomplete
                this.selectedPerson = null

                //  Clear the searchList
                this.searchList = null

                //  Focus the autocomplete
                if (this.$refs.personsAutocomplete) this.$refs.personsAutocomplete.focus()
            })
        },
        async personsSearch(): Promise<void> {
            //  If search text does NOT exist, publish searchCleared event
            if (!this.searchtext) {
                this.searchList = null
                return this.$emit('searchCleared')
            }

            //  Else, assemble the search payload
            const payload = { searchtext: this.searchtext, limit: 30 }

            //  Start the loading spinner
            this.loading = true

            //  Else, sent the search request to the API
            const persons = await this.$store.dispatch('personsSearch', payload)

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed, do nothing
            if (!persons) return

            //  Set the search results
            this.searchList = persons

            //  If excludePersons is specified, exclude persons
            if (this.excludePersons) {
                this.searchList = this.searchList.filter(
                    ({ id }) => !this.excludePersons.includes(id)
                )

                //  Filter out opted out contacts
                this.searchList = this.searchList.filter(
                    ({ phone_default }) => !this.optedOut.includes(phone_default.msisdn)
                )
            }

            //  Publish the search results
            this.$emit('searchCompleted', persons)

            Analytics.track('LocalSearchUsed', {
                search_type: 'Contacts',
                search_query: payload.searchtext
            })
        },
        paginate(): void {
            //  Check if we're able to paginate
            const next = !this.nextPage || this.nextPage <= this.lastPage

            //  If another page does NOT exist, do nothing
            if (!next) return

            //  Else, assemble pagination params
            const params = { page: this.nextPage || 1 }

            //  Send the pagination request
            this.$store.dispatch('personsAutocompletePaginate', params)
        },
        phone(person: Person): string {
            //  If number does not exist, return nothing (for users)
            if (!person.phone_default) return

            //  Grab the msisdn from this person
            const msisdn = person.phone_default.msisdn

            //  Make our phone all pretty
            const phone = this.$options.filters.phone(msisdn)

            //  Return the prettified :) phone number
            return phone
        },
        popNewContact(model: Person): void {
            //  Make sure the menu closes
            this.$refs.personsAutocomplete.blur()

            //  Open our new contact selector form
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Add Contact',
                icon: 'mdi-account',
                color: 'primary',
                component: 'new-contact-selector',
                closeOnSubmit: true,
                props: {
                    model: model,
                    withImport: true
                },
                callback: async (person: Person) => {
                    //  Submit this to the parent
                    this.onPersonSelectedHandler(person)
                }
            })
        },
        reset(): void {
            this.$nextTick(() => {
                this.selectedPerson = null
                this.searchProp = null
            })
        }
    }
})
